var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafe25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.308,
    height: 60.593,
    viewBox: "0 0 52.308 60.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #192a40;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "safe-25",
    transform: "translate(-113.729 -50.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    className: "cls-1",
    d: "M118.837,60.346a1.4,1.4,0,0,1-.839-2.52c6.42-4.794,15.678-7.544,25.4-7.544,9.683,0,18.916,2.73,25.334,7.492a1.4,1.4,0,1,1-1.667,2.248c-5.945-4.41-14.571-6.94-23.666-6.94-9.131,0-17.779,2.546-23.726,6.987a1.4,1.4,0,0,1-.837.277Z",
    transform: "translate(-3.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    className: "cls-1",
    d: "M139.443,218.933a1.367,1.367,0,0,1-.554-.115c-.843-.361-20.66-9.077-24.188-24.864-.969-6.04-1.215-15.239-.729-26.687a1.415,1.415,0,0,1,1.459-1.34,1.4,1.4,0,0,1,1.34,1.459c-.477,11.262-.242,20.268.68,26.04,3.2,14.326,22.355,22.739,22.549,22.822a1.4,1.4,0,0,1-.556,2.685Z",
    transform: "translate(0 -108.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    className: "cls-1",
    d: "M485.749,213.643a1.4,1.4,0,0,1-.538-2.691c.2-.085,20.085-8.522,23.3-22.894.971-6.1,1.281-15.726.831-26.332a1.4,1.4,0,1,1,2.8-.119c.458,10.786.137,20.618-.881,26.976-3.546,15.885-24.1,24.59-24.97,24.954a1.41,1.41,0,0,1-.538.106Z",
    transform: "translate(-346.304 -102.766)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    className: "cls-1",
    d: "M288.269,466.819a1.4,1.4,0,0,1-.99-.41L276.7,455.832a1.4,1.4,0,0,1,1.979-1.979l10.579,10.577a1.4,1.4,0,0,1-.99,2.39Z",
    transform: "translate(-151.895 -376.705)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    className: "cls-1",
    d: "M438.879,365.859a1.4,1.4,0,0,1-.992-2.387l17.593-17.667a1.4,1.4,0,1,1,1.985,1.975L439.87,365.449A1.4,1.4,0,0,1,438.879,365.859Z",
    transform: "translate(-302.505 -275.745)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe25);
export default __webpack_public_path__ + "static/media/safe-25.3cee121b6ec747134a804c4282be7364.svg";
export { ForwardRef as ReactComponent };